// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".meet-bottom-menu {\n  z-index: 14;\n  height: 64px;\n  animation-duration: 0.3s;\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  min-width: 412px;\n  display: flex;\n  align-items: center;\n}\n.meet-bottom-menu .menu-btn-spacer {\n  width: 10px;\n}\n@media (max-width: 768px) {\n.desktop-only {\n    display: none;\n}\n}", ""]);
// Exports
module.exports = exports;
